import { getCurrentAppConfigApiHost } from "shared/config/appConfig"

import { request } from "./request"

export const notificationsApi = {
  getNotifications: (userId: string) => {
    return request('GET', `/api/2/users/${userId}/news`)
  },
  getUnreadNotifications: (userId: string) => {
    return request('GET', `/api/2/users/${userId}/news`, { is_viewed: false })
  },
  getReadNotifications: (userId: string) => {
    return request('GET', `/api/2/users/${userId}/news`, { is_viewed: true })
  },
  markNotificationAsRead: (userId: string, notificationId: string) => {
    return request('PATCH', `/api/2/users/${userId}/news/${notificationId}`, { is_viewed: true })
  },
  // markAllNotificationsAsRead: (userId: string) => {
  //   return request('PATCH', `/api/2/users/${userId}/news`, { is_viewed: true })
  // },
  batchMarkNotificationsAsRead: (userId: string, notificationIds: string[]) => {
    const requests = notificationIds.map((notificationId) => ({
      method: 'PATCH',
      url: `${getCurrentAppConfigApiHost()}/api/2/users/${userId}/news/${notificationId}`,
      params: { is_viewed: true }
    }))

    return request('POST', `/api/2/users/${userId}/batched_ops/`, { requests })
  },
  checkBatchMarkNotificationsAsRead: (userId: string, operationId: string) => {
    return request('GET', `/api/2/users/${userId}/batched_ops/${operationId}`)
  }
}